import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';


@Pipe({
  name: 'storageUrl'
})
export class StorageUrlPipe implements PipeTransform {

  private storageURL!: string;

  constructor(
    private sanitizer: DomSanitizer
  ) {
    this.storageURL = environment.apiConfig.storageURL;
  }

  transform(value?: string) {
    return value ?  this.sanitizer.bypassSecurityTrustResourceUrl(this.storageURL + value) : '';
  }

}
